import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 推广人员（查询列表）
 * @param {*} query
 */
export const promoterlist = (query) => {
    return request({
        url: `${prefix}/member/promoter/list`,
        method: 'get',
        params: query
    })
}


/**
 * 推广商品（查询列表）
 * @param {*} query
 */
export const marketingChargelist = (query) => {
    return request({
        url: `${prefix}/marketingCharge/list`,
        method: 'get',
        params: query
    })
}

/**
 * 推广商品（创建）
 * @param {*} query
 */
export const marketingChargeCreate = (query) => {
    return request({
        url: `${prefix}/marketingCharge`,
        method: 'post',
        data: query
    })
}

/**
* 推广商品（创建）
* @param {*} query
*/
export const marketingChargeEdit = (query) => {
    return request({
        url: `${prefix}/marketingCharge`,
        method: 'put',
        data: query
    })
}


/**
* 推广商品（删除）
* @param {*} query
*/
export const marketingChargeDelete = (query) => {
    return request({
        url: `${prefix}/marketingCharge`,
        method: 'delete',
        data: query
    })
}




/**
* 推广人员（修改，含清退）
* @param {*} query
*/
export const memberpromoterEdit = (query) => {
    return request({
        url: `${prefix}/member/promoter`,
        method: 'put',
        data: query
    })
}



/**
* 推广人员（审核修改）
* @param {*} query
*/
export const promotercheck = (query) => {
    return request({
        url: `${prefix}/member/promoter/check`,
        method: 'put',
        data: query
    })
}


/**
 * 推广订单（查询列表）
 * @param {*} query
 */
export const referrerOrderlist = (query) => {
    return request({
        url: `${prefix}/member/promoter/referrerOrder/list`,
        method: 'get',
        params: query
    })
}


/**
 * 收益（查询收益记录列表） 
 * @param {*} query
 */
export const profitlogs = (query) => {
    return request({
        url: `${prefix}/member/profit/logs`,
        method: 'get',
        params: query
    })
}


/**
 * 返佣提现（审核通过）
 * @param {*} query
 */
export const withdrawaccess = (query) => {
    return request({
        url: `${prefix}/member/withdraw/access`,
        method: 'post',
        data: query
    })
}


/**
* 帮助中心（创建）
* @param {*} query
*/
export const helpArticlecreate = (query) => {
    return request({
        url: `${prefix}/referrer/helpArticle`,
        method: 'post',
        data: query
    })
}


/**
 * 帮助中心（查询列表）
 * @param {*} query
 */
export const helpArticlelist = (query) => {
    return request({
        url: `${prefix}/referrer/helpArticle/list`,
        method: 'get',
        params: query
    })
}


/**
* 帮助中心（删除）
* @param {*} query
*/
export const helpArticledelete = (query) => {
    return request({
        url: `${prefix}/referrer/helpArticle`,
        method: 'delete',
        data: query
    })
}


/**
 * 帮助中心（查询详情）
 * @param {*} query
 */
export const helpArticleOne = (query) => {
    return request({
        url: `${prefix}/referrer/helpArticle`,
        method: 'get',
        params: query
    })
}



/**
* 帮助中心（修改）
* @param {*} query
*/
export const helpArticleedit = (query) => {
    return request({
        url: `${prefix}/referrer/helpArticle`,
        method: 'put',
        data: query
    })
}


/**
 * 推广邀请（查询列表）
 * @param {*} query
 */
export const referrerInviterlist = (query) => {
    return request({
        url: `${prefix}/member/promoter/referrerInviter/list`,
        method: 'get',
        params: query
    })
}


/**
 * 推广邀请（查询列表）
 * @param {*} query
 */
export const smscodemobile = (query) => {
    return request({
        url: `${prefix}/member/withdraw/smscode/mobile`,
        method: 'get',
        params: query
    })
}


/**
* 返佣提现（提现验证码发送）
* @param {*} query
*/
export const withdrawsendsmscode = (query) => {
    return request({
        url: `${prefix}/member/withdraw/send/smscode`,
        method: 'post',
        data: query
    })
}



/**
 * 学长推广学生（ 查询列表）
 * @param {*} query
 */
export const seniorStudentList = (query) => {
    return request({
        url: `${prefix}/referrer/seniorStudent/list`,
        method: 'get',
        params: query
    })
}

/**
 * 学长推广学生（查询详情）
 * @param {*} query
 */
export const seniorStudentOne = (query) => {
    return request({
        url: `${prefix}/referrer/seniorStudent`,
        method: 'get',
        params: query
    })
}



/**
* 返佣提现（提现验证码发送）
* @param {*} query
*/
export const seniorStudentEdit = (query) => {
    return request({
        url: `${prefix}/referrer/seniorStudent`,
        method: 'put',
        data: query
    })
}

